import { createGlobalStyle } from "styled-components";

interface Props {
  theme: {
    body?: string;
    text?: string;
    background?: string;
  };
}

const GlobalStyles = createGlobalStyle`
 body {
    background: ${({ theme }: Props) => theme.body};
    color: ${({ theme }: Props) => theme.text};
    font-family: Tahoma, Helvetica, Arial, Roboto, sans-serif;
    transition: height 0.50s linear;
    margin: 0;
  }

  .section {
    background: ${({ theme }: Props) => theme.background};
  }

  /* .recharts-wrapper {
      z-index: -1;
  } */
`;

export default GlobalStyles;
